import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_common_up_ triangle",
  "use": "lc_common_up_ triangle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_common_up_ triangle\"><defs><style type=\"text/css\"></style></defs><path d=\"M1024 853.333333l-512-682.666666-512 682.666666z\" p-id=\"4192\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol